import { Box, IconButton, Tab, Tabs, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import React from 'react';
import { a11yProps } from '../components/common';
import useStyles from '../styles';

export default function EditVersionHeader({
  isModal,
  title,
  onClose,
  tabValue,
  onTabChange
}) {
  const classes = useStyles();

  return (
    <Box className={clsx(classes.modalHeader, isModal && classes.modalHeaderPadded)}>
      {isModal && (
        <Box className={classes.modalTitleRow}>
          <Box className={classes.modalTitleGroup}>
            <Typography component="h2" className={classes.modalTitle}>
              {title}
            </Typography>
          </Box>
          <IconButton
            aria-label="Đóng cửa sổ"
            size="small"
            onClick={onClose}
            className={classes.closeButton}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
      <Tabs
        value={tabValue}
        onChange={onTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="device configuration tabs"
        className={classes.tabs}
      >
        <Tab label="Cấu hình thiết bị" {...a11yProps(0)} />
        <Tab label="Cấu hình cảm biến xăng dầu" {...a11yProps(1)} />
        <Tab label="Cấu hình tích truyền" {...a11yProps(2)} />
      </Tabs>
    </Box>
  );
}
